import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModuleFlow, handleError } from '../../../../shared/utils/error.utils';
import { buildHttpParams } from '../../../../shared/utils/http.utils';
import { RingRepository } from '../../domain/repository';
import { ApiResponse } from '../../../../shared/dto/response/api-response.dto';
import { getApiBaseUrl } from '../../../../shared/config/runtime-config';
import {
  RingFindAllRequest,
  RingFindAllResponse,
  RingFindRequest,
  RingFindResponse,
} from '../../domain/dto';

@Injectable({ providedIn: 'root' })
export class RingRepositoryImpl implements RingRepository {
  constructor(private http: HttpClient) {}

  findAllPath(): string {
    return this.apiUrl;
  }

  findAll(
    payload: RingFindAllRequest = {},
  ): Observable<HttpResponse<RingFindAllResponse>> {
    const params = buildHttpParams(payload);

    return this.http
      .get<ApiResponse<RingFindAllResponse>>(this.findAllPath(), {
        observe: 'response',
        params,
      })
      .pipe(
        map((response) => response.clone({ body: response.body?.data ?? [] })),
        catchError((error) => handleError(ModuleFlow.RingFindAll, error)),
      );
  }

  find(payload: RingFindRequest): Observable<HttpResponse<RingFindResponse>> {
    return this.http
      .get<ApiResponse<RingFindResponse>>(`${this.apiUrl}/${payload.id}`, {
        observe: 'response',
      })
      .pipe(
        map((response) => response.clone({ body: response.body?.data })),
        catchError((error) => handleError(ModuleFlow.RingFind, error)),
      );
  }

  private get apiUrl(): string {
    return getApiBaseUrl('catalogs/rings');
  }
}


